
const RUC_SIZE = 11
const RUC_START_WITHS = ['10', '15', '16', '17', '20']

const DocumentRules = {
  isValidRuc: (documentNumber) => {
    if (documentNumber.length !== RUC_SIZE || !RUC_START_WITHS.filter(word => documentNumber.startsWith(word))) {
      return false
    }
    let sum = 0
    let factor = 6
    for (let i = 0; i < documentNumber.length - 1; i++) {
      if (i === 4) {
        factor = 8
      }
      const digit = documentNumber.charAt(i) - '0'
      factor--
      sum += (digit * factor)
    }
    let rest = sum % 11
    rest = 11 - rest
    if (rest >= 10) {
      rest = rest - 10
    }
    return documentNumber.charAt(documentNumber.length - 1) === rest
  },
  getDocumentTypeZS: (documentNumber) => {
    documentNumber = documentNumber.trim()
    if (documentNumber.length === 8) {
      return 1
    }
    if (documentNumber.length === 11 && this.isValidRuc(documentNumber)) {
      return 3
    }
    if (documentNumber.length >= 5 && documentNumber.length <= 12) {
      return 2
    }
    return -1
  },
  getDocumentTypeBUC: (docType) => {
    switch (docType + '') {
    case 1:
      return 'DNI'
    case 2:
      return 'CE'
    case 3:
      return 'RUC'
    default:
      return ''
    }
  }
}

export default DocumentRules



// WEBPACK FOOTER //
// ./src/interfaces/documentRules.js